import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostArea2025/layout/Component/FormTitle';
import FormInput from '@src/mobile/phtvHostArea2025/layout/Component/FormInput';
import FormInputDate from '@src/mobile/phtvHostArea2025/layout/Component/FormInputDate';
import FormSelect from '@src/mobile/phtvHostArea2025/layout/Component/FormSelect';
import FormWaring from '@src/mobile/phtvHostArea2025/layout/Component/FormWaring';
import FormTextarea from '@src/mobile/phtvHostArea2025/layout/Component/FormTextarea';
import { area } from '@src/utils/area';

const Required = ({ formData, setFormDataHandle, warningTextList, languages, updateSuccess }) => {
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.onlineSignUp}>
            <div className={styles.formList}>
                <div className={styles.formListBox}>
                    {/* 姓名 */}
                    <FormTitle name="name" title={area[languages].name.title} warningText={warningTextList['name']} isRequired={true} />
                    <FormInput name="name" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['name']} />
                    {/* 性别 */}
                    <FormTitle name="gender" title={area[languages].gender.title} warningText={warningTextList['gender']} isRequired={true} />
                    <FormSelect
                        name="gender"
                        formData={formData}
                        changeInputHandle={changeInputHandle}
                        optionValueList={[area[languages].gender.man, area[languages].gender.woman]}
                        languages={languages}
                    />
                    <FormWaring warningText={warningTextList['gender']} />
                    {/* 年龄 */}
                    <FormTitle title={area[languages].age.title} name="age" warningText={warningTextList['age']} isRequired={true} />
                    <FormInput name="age" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['age']} />
                    {/* 教育程度 */}
                    <FormTitle title={area[languages].education_level.title} name="education_level" warningText={warningTextList['education_level']} isRequired={true} />
                    <FormInput name="education_level" formData={formData} changeInputHandle={changeInputHandle} placeholder={area[languages].education_level.placeholder} />
                    <FormWaring warningText={warningTextList['education_level']} />
                    {/* 现职 */}
                    <FormTitle name="career" title={area[languages].career.title} warningText={warningTextList['career']} />
                    <FormInput name="career" formData={formData} changeInputHandle={changeInputHandle} placeholder={area[languages].career.placeholder} />
                    <FormWaring warningText={warningTextList['career']} />
                    {/* 语言能力 */}
                    <FormTitle title={area[languages].language.title} name="language" warningText={warningTextList['language']} isRequired={true} />
                    <FormInput name="language" formData={formData} changeInputHandle={changeInputHandle} placeholder={area[languages].language.placeholder} />
                    <FormWaring warningText={warningTextList['language']} />
                    {/* 国家和地区 */}
                    <FormTitle name="country" title={area[languages].country.title} warningText={warningTextList['country']} isRequired={true} />
                    <FormInput name="country" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['country']} />
                    {/* 目前所在城市 */}
                    <FormTitle name="living_city" title={area[languages].living_city.title} warningText={warningTextList['living_city']} isRequired={true} />
                    <FormInput name="living_city" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['living_city']} />
                    {/* 护照 */}
                    <FormTitle name="documents" title={area[languages].documents.title} warningText={warningTextList['documents']} isRequired={true} />
                    {languages !== 'en' ? (
                        <FormInput name="documents" formData={formData} changeInputHandle={changeInputHandle} placeholder={area[languages].documents.placeholder} />
                    ) : (
                        <FormTextarea placeholder={area[languages].documents.placeholder} formData={formData} name="documents" changeInputHandle={changeInputHandle} updateSuccess={updateSuccess} />
                    )}
                    <FormWaring warningText={warningTextList['documents']} />
                    {/* 手机号 */}
                    <FormTitle name="mobile_number" title={area[languages].mobile_number.title} warningText={warningTextList['mobile_number']} isRequired={true} />
                    <FormInput name="mobile_number" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['mobile_number']} />
                    {/* 邮箱 */}
                    <FormTitle name="email" title={area[languages].email.title} warningText={warningTextList['email']} isRequired={true} />
                    <FormInput name="email" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormWaring warningText={warningTextList['email']} />
                    {/* 微信 */}
                    <FormTitle name="wechat_id" title={area[languages].wechat_id.title} warningText={warningTextList['wechat_id']} />
                    <FormInput name="wechat_id" formData={formData} changeInputHandle={changeInputHandle} placeholder={area[languages].wechat_id.placeholder} />
                    <FormWaring warningText={warningTextList['wechat_id']} />
                    {/* 社交网络账号 */}
                    <FormTitle name="social_media_accounts" title={area[languages].social_media_accounts.title} warningText={warningTextList['social_media_accounts']} />
                    <FormTextarea
                        placeholder={area[languages].social_media_accounts.placeholder}
                        formData={formData}
                        name="social_media_accounts"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormWaring warningText={warningTextList['social_media_accounts']} />
                    {/* 最高学历 */}
                    <FormTitle name="major" title={area[languages].major.title} warningText={warningTextList['major']} isRequired={true} />
                    <FormInput name="major" formData={formData} changeInputHandle={changeInputHandle} placeholder={area[languages].major.placeholder} />
                    <FormWaring warningText={warningTextList['major']} />
                    {/* 工作经验 */}
                    <FormTitle name="work_experience" title={area[languages].work_experience.title} warningText={warningTextList['work_experience']} />
                    <FormTextarea formData={formData} name="work_experience" changeInputHandle={changeInputHandle} updateSuccess={updateSuccess} />
                    <FormWaring warningText={warningTextList['work_experience']} />
                    {/* 自我介绍 */}
                    <FormTitle name="self_introduction" title={area[languages].self_introduction.title} warningText={warningTextList['self_introduction']} isRequired={true} />
                    <FormTextarea
                        limitWord={40}
                        placeholder={area[languages].self_introduction.placeholder}
                        formData={formData}
                        name="self_introduction"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormWaring warningText={warningTextList['self_introduction']} />
                </div>
            </div>
        </div>
    );
};

Required.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    languages: PropTypes.string,
    updateSuccess: PropTypes.bool,
};

export default errorBoundary(Required);
